<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<h1 class="tw-flex tw-flex-row tw-flex-wrap tw-justify-between" *ngIf="!isMordal">
    <span class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
        手数料報告画面
    </span>
    <mat-icon style="opacity: 0.5;">info_outline</mat-icon>
</h1>
<h2 class="tw-flex tw-flex-row tw-flex-wrap tw-justify-between" *ngIf="isMordal">
    <span class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
        手数料報告画面
    </span>
    <mat-icon [ngStyle]="{ 'opacity': isEdit ? '' : '0.5' }" (click)=" isEdit && onClickIcon()">info_outline</mat-icon>
</h2>
<form [formGroup]="regInfRequestForm" #formDirective="ngForm" (ngSubmit)="regist(formDirective)">
    <app-sgke140d-info *ngIf="newInitialhyojiInfo || correctionInitialhyojiInfo"
        [newInitialhyojiInfo]="newInitialhyojiInfo" [correctionInitialhyojiInfo]="correctionInitialhyojiInfo"
        [gamenHyojiInfo]="gamenHyojiInfo" [isMordal]="isMordal" [isEdit]="isEdit" (cancelButtonClickEmitter)="cancel()"
        (removeButtonClickEmitter)="remove()">
    </app-sgke140d-info>
    <div *ngIf="isMordal &&(!newInitialhyojiInfo && !correctionInitialhyojiInfo)">
        <div
            class="btn_area_right tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
            <mat-dialog-actions>
            <button type="button" (click)="cancel()" mat-raised-button color="primary" class="btn">キャンセル</button>
            </mat-dialog-actions>
        </div>
    </div>
</form>